import { render, staticRenderFns } from "./CompareTableColumnsChoices.vue?vue&type=template&id=79a66c2d&scoped=true&"
import script from "./CompareTableColumnsChoices.vue?vue&type=script&lang=ts&"
export * from "./CompareTableColumnsChoices.vue?vue&type=script&lang=ts&"
import style0 from "./CompareTableColumnsChoices.vue?vue&type=style&index=0&id=79a66c2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a66c2d",
  null
  
)

export default component.exports